import React from "react";
import { useQuickSightKPI } from "@/hooks/useKpiReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsKpiDashboard from "@/components/organisms/KpiDashboard";

function KPIReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightKPI();

  return (
    <AWSReportsTemplate
      title="AWS KPI Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsKpiDashboard />
    </AWSReportsTemplate>
  );
}

export default KPIReports;
